import React from "react";
import { Form, Input } from "antd";

function Inputs() {
  return (
    <>
      <div className="custom-title !text-[#111928] rounded-[.5rem]">Inputs</div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="agrochemicalAccess"
          label={"Distance to Agroinputs"}
        >
          <Input className="input" />
        </Form.Item>
      </div>
    </>
  );
}

export default Inputs;
